// extracted by mini-css-extract-plugin
export var cardIcon = "_6r-4";
export var checkboxCard = "_6r-0";
export var checkboxCardSelected = "_6r-1";
export var disabled = "_6r-2";
export var outerBorder = "_6r-3";
export var spacerMedium = "_6r-7";
export var spacerSmall = "_6r-6";
export var spacerXsmall = "_6r-5";